module.exports = __webpack_public_path__ + "static/media/ios-photos.299d5c0c.svg";